<template>
    <div id="Test">
        test
    </div>
</template>

<script>
    export default {
        name: "Test"
    }
</script>

<style scoped>

</style>